<template>
    <div
        class="activity-location"
        :class="{
            'activity-location__no-map': activity.location == null
        }"
    >
        <div v-if="activity.location != null" class="activity-location__map">
            <GmapMap
                v-if="
                    activity.location[0] != null &&
                        activity.location[0] != undefined
                "
                :id="activity.id"
                :center="{
                    lat: parseFloat(activity.location[0].lat),
                    lng: parseFloat(activity.location[0].long)
                }"
                :zoom="9"
                :options="mapStyle"
                style="width: 100%; height: 160px"
            >
                <GmapMarker
                    v-for="location in activity.location"
                    :key="location.id"
                    :position="{
                        lat: parseFloat(location.lat),
                        lng: parseFloat(location.long)
                    }"
                    :center="{
                        lat: parseFloat(location.lat),
                        lng: parseFloat(location.long)
                    }"
                    :icon="{ url: '/Content/img/pin-blue.png' }"
                />
            </GmapMap>
        </div>
        <div class="activity-location__info">
            <h2 class="h4 mb-2">
                {{ activity.providerName }}
            </h2>
            <ul>
                <li
                    v-if="
                        activity.providerId != null &&
                            activity.providerId[0] != null &&
                            activity.providerId[0].website != null
                    "
                >
                    <a :href="activity.providerId[0].website" target="_blank">
                        {{ websiteName }}
                    </a>
                </li>
                <li></li>

                <li v-if="activity.location != null">
                    <h4>Locatie</h4>
                    <div
                        v-for="location in activity.location"
                        :key="location.Id"
                        class="mb-2"
                    >
                        <span v-if="location.title != null">{{
                            location.title
                        }}</span
                        ><br />
                        {{ addressBuilder(location) }} <br />

                        <a
                            v-if="location.emailAddress != null"
                            :href="'mailto:' + location.emailAddress"
                            target="_blank"
                        >
                            {{ location.emailAddress }}
                        </a>
                        <a
                            v-else-if="
                                activity.providerId != null &&
                                    activity.providerId[0] != null &&
                                    activity.providerId[0].email != null
                            "
                            :href="'mailto:' + activity.providerId[0].email"
                            target="_blank"
                        >
                            {{ activity.providerId[0].email }}
                        </a>
                        <br />
                        <a
                            v-if="location.phoneNumber != null"
                            :href="'tel:' + location.phoneNumber"
                        >
                            {{ location.phoneNumber }}
                        </a>
                        <a
                            v-else-if="
                                activity.providerId != null &&
                                    activity.providerId[0] != null &&
                                    activity.providerId[0].phoneNumber != null
                            "
                            :href="'tel:' + activity.providerId[0].phoneNumber"
                        >
                            {{ activity.providerId[0].phoneNumber }}
                        </a>
                    </div>
                </li>
                <li>
                    <p
                        v-if="
                            activity.coProvider != null &&
                                activity.coProvider.length > 0 &&
                                activity.coProvider[0].name != null
                        "
                    >
                        <i>
                            Deze activiteit wordt mede mogelijk gemaakt door
                            {{ activity.coProvider[0].name }}
                        </i>
                    </p>
                </li>
                <li
                    v-if="
                        activity.infoRequestUrl != null &&
                            activity.infoRequestUrl != ''
                    "
                >
                    <p>Vragen over de activiteit? Neem contact op.</p>
                    <p class="text-center w-100">
                        <a
                            :href="activity.infoRequestUrl"
                            class="btn mb-4 mt-2"
                        >
                            <span>
                                Neem contact op
                            </span>
                        </a>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
const mapStyle = [
    {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
            {
                saturation: 36
            },
            {
                color: '#333333'
            },
            {
                lightness: 40
            }
        ]
    },
    {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                visibility: 'on'
            },
            {
                color: '#ffffff'
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off'
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#fefefe'
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#fefefe'
            },
            {
                lightness: 17
            },
            {
                weight: 1.2
            }
        ]
    },
    {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
            {
                color: '#e9e9e9'
            },
            {
                lightness: 20
            }
        ]
    },
    {
        featureType: 'landscape.natural',
        elementType: 'geometry.stroke',
        stylers: [
            {
                visibility: 'on'
            }
        ]
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
            {
                color: '#f5f5f5'
            },
            {
                lightness: 21
            }
        ]
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
            {
                color: '#bfe29b'
            },
            {
                lightness: 21
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 17
            }
        ]
    },
    {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 29
            },
            {
                weight: 0.2
            }
        ]
    },
    {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 18
            }
        ]
    },
    {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
            {
                color: '#ffffff'
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
            {
                color: '#f2f2f2'
            },
            {
                lightness: 19
            }
        ]
    },
    {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
            {
                color: '#c6e7ff'
            },
            {
                lightness: 17
            }
        ]
    }
];

export default {
    props: {
        activity: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            mapStyle: { styles: mapStyle }
        };
    },
    computed: {
        websiteName() {
            if (
                this.activity.providerId != null &&
                this.activity.providerId[0] != null &&
                this.activity.providerId[0].website != null
            ) {
                return this.activity.providerId[0].website.replace(
                    /(^\w+:|^)\/\//,
                    ''
                );
            }

            return '';
        }
    },
    methods: {
        addressBuilder(location) {
            let address = '';

            if (location != null) {
                if (location.street != null && location.street != '') {
                    address += location.street;
                }

                if (
                    location.houseNumber != null &&
                    location.houseNumber != ''
                ) {
                    address += ' ' + location.houseNumber;
                }

                if (
                    location.houseNumberAddition != null &&
                    location.houseNumberAddition != ''
                ) {
                    address += ' ' + location.houseNumberAddition;
                }

                address += ', ';

                if (location.postalCode != null && location.postalCode != '') {
                    address += location.postalCode;
                }

                if (location.city != null && location.city != '') {
                    address += ' ' + location.city;
                }
            }

            return address.trim();
        }
    }
};
</script>

<style lang="scss">
.activity-location {
    background-color: $white;
    color: $black;
    font-size: 1.125rem;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
    border-radius: 7px;
    padding: 0 25px 10px 25px;
    position: relative;
}

.activity-location__map {
    margin: 0 -25px 30px -25px;
}

.activity-location ul {
    list-style: none;
    padding: 0;
    margin: 0;
    word-break: break-word;
    line-height: 1.5;

    li {
        margin-bottom: 15px;
    }
}

.activity-location__no-map {
    padding-top: 2rem;
}

.vue-map-container,
.vue-map-container .vue-map {
    width: 100%;
    height: 100%;
}
</style>
